/**
 * Created by lu on 2018/5/8.
 */
var nb = require('../../nb');
module.exports = nb.define({
    parent: require('./Dialog'),
    slot: {
        content: ['html', {
            'class': 'confirm-content',
            $html: nb.bind('text')
        }],
        footer: ['html', [{
            tag: 'button',
            $name: 'cancel',
            class: 'btn btn-line-gold btn-md btn-cancel',
            $text: nb.bind('cancelBtnText')
        }, {
            tag: 'button',
            $name: 'confirm',
            class: 'btn btn-solid-gold btn-md btn-confirm',
            $text: nb.bind('confirmBtnText')
        }]]
    },
    method: {
        init: function () {
            var self = this;
            this.$('confirm').on('click', function () {
                var model = self.getModel();
                model.set('confirm',new Date());
            });
            this.$('cancel').on('click', function () {
                var model = self.getModel();
                model.set('cancel',new Date());
            });
        }
    }
});


//////////////////
// WEBPACK FOOTER
// ../src/js/view/modal/Confirm.js
// module id = 22
// module chunks = 0 1 2 3 4 7 8 9 10 12 13 14 15 16 18 19 20 21 22 23 25 26 27 28 29 30 34